import { TENANT, Tenant } from './tenant';

const defaultTenantName = 'Avelios Medical';

/**
 * Mapping of tenants to their human-readable name.
 */
const tenantToNameMap = new Map<Tenant, string>([
  [Tenant.avelios, defaultTenantName],
  [Tenant.sana, 'MeineSana'],
]);

const tenantToCopyrightNameMap = new Map<Tenant, string>([
  [Tenant.avelios, defaultTenantName],
  [Tenant.sana, 'Sana IT Services GmbH'],
]);

/**
 * Tenant name. Use this const in all places where the product name is being rendered.
 * E.g. footer, navbar
 */
export const TENANT_NAME: string = ((tenant: Tenant) => {
  const tenantName = tenantToNameMap.get(tenant);

  if (tenantName) {
    return tenantName;
  }

  console.warn(`No name defined for tenant ${tenant}. Falling back to default.`);
  return defaultTenantName;
})(TENANT);

export const COPYRIGHT_NAME: string = ((tenant: Tenant) => {
  const tenantName = tenantToCopyrightNameMap.get(tenant);

  if (tenantName) {
    return tenantName;
  }

  return defaultTenantName;
})(TENANT);
